/**
 * 成交公告列表页
 */
export const TRANSACTION_ANNOUNCEMENT_LIST_PAGE_PATH =
  '/announcement/transaction/list'

/**
 * 成交公告新增页
 */
export const TRANSACTION_ANNOUNCEMENT_CREATE_PAGE_PATH =
  '/announcement/transaction/create'

/**
 * 成交公告编辑页
 */
export const TRANSACTION_ANNOUNCEMENT_EDIT_PAGE_PATH =
  '/announcement/transaction/edit'

/**
 * 成交公告详情页
 */
export const TRANSACTION_ANNOUNCEMENT_DETAIL_PAGE_PATH =
  '/announcement/transaction/detail'

/**
 * 频道管理页
 */
export const TRANSACTION_ANNOUNCEMENT_CHANNEL_PAGE_PATH =
  '/announcement/transaction/channel'
